// Cart Page
// Desktop version (≥768px)

import { useEffect } from 'react';
import { useCart } from '@/contexts/CartContext';
import { useNavigate } from 'react-router-dom';
import DesktopLayout from '@/components/layout/DesktopLayout';
import { CartItem } from '@/components/cart/CartItem';
import { CartSummary } from '@/components/cart/CartSummary';
import type { CartItem as CartItemType } from '@/types';
import styles from './CartPage.module.css';

export default function CartPage() {
  const { items, isLoading, error, refreshCart, updateQuantity, removeItem } = useCart();
  const navigate = useNavigate();

  useEffect(() => {
    // Sync cart on page load to ensure latest prices/stock
    refreshCart();
  }, [refreshCart]);

  const handleUpdateQuantity = async (itemId: string, quantity: number) => {
    try {
      await updateQuantity(itemId, quantity);
    } catch (err) {
      console.error('Failed to update quantity:', err);
    }
  };

  const handleRemoveItem = async (itemId: string) => {
    try {
      await removeItem(itemId);
    } catch (err) {
      console.error('Failed to remove item:', err);
    }
  };

  return (
    <DesktopLayout>
      <div className={styles.cartPage}>
        <div className={styles.container}>
          <h1 className={styles.title}>購物車</h1>

          {isLoading && items.length === 0 ? (
            <div className={styles.loading}>載入中...</div>
          ) : error ? (
            <div className={styles.error}>{error}</div>
          ) : items.length === 0 ? (
            <div className={styles.empty}>
              <p className={styles.emptyMessage}>您的購物車是空的</p>
              <button
                className={styles.shopButton}
                onClick={() => navigate('/products')}
              >
                開始購物
              </button>
            </div>
          ) : (
            <div className={styles.cartContent}>
              <div className={styles.itemsList}>
                {items.map((item: CartItemType) => (
                  <CartItem
                    key={item.id}
                    item={item}
                    onUpdateQuantity={handleUpdateQuantity}
                    onRemove={handleRemoveItem}
                  />
                ))}
              </div>

              <div className={styles.summarySection}>
                <CartSummary />
              </div>
            </div>
          )}
        </div>
      </div>
    </DesktopLayout>
  );
}
